import React from 'react'

function Slidingtext() {
  return (
    <div class="mt-3 wrapper bg-gradient-to-r from-pink-600 to bg-purple-700 text-center md:p-4 md:text-xl">
      <p className="animate-bounce px-3 py-2 text-white font-semibold ">
      Welcome to <em>Kothari Mobile Zone.</em> </p>
      <p className="animate-bounce p-1 text-white font-semibold ">
      कोठारी मोबाइल जोन में आपका स्वागत है। </p>
    </div>
    
  )
}

export default Slidingtext